"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseMapType = exports.Source = exports.MapboxglMap = void 0;
var tslib_1 = require("tslib");
var mapbox_gl_1 = require("mapbox-gl");
Object.defineProperty(exports, "MapboxglMap", { enumerable: true, get: function () { return mapbox_gl_1.Map; } });
var l7_source_1 = (0, tslib_1.__importDefault)(require("@antv/l7-source"));
exports.Source = l7_source_1.default;
/**
 * 底图类型
 */
var BaseMapType;
(function (BaseMapType) {
    BaseMapType["Amap"] = "amap";
    BaseMapType["Mapbox"] = "mapbox";
})(BaseMapType = exports.BaseMapType || (exports.BaseMapType = {}));
//# sourceMappingURL=map.js.map